import { SelectedColor } from "store/features/colorPicker/types";
import { getColorInfo } from "./getColorInfo";
import tinycolor from "tinycolor2";

export const getSelectedColorInfo = (r: number, g: number, b: number, a: number): SelectedColor => {
    const colorInfo = getColorInfo(r, g, b, a);
    const tiny = tinycolor({ r, g, b, a });
    const complement = tiny.complement().toRgb();
    const complementary = getColorInfo(complement.r, complement.g, complement.b, complement.a);
    const analogous = tiny.analogous().map((_color) => {
        const color = _color.toRgb();
        return getColorInfo(color.r, color.g, color.b, color.a);
    });

    const monoChromatic = tiny
        .monochromatic()
        .sort((a, b) => b.toHsl().l - a.toHsl().l)
        .map((_color) => {
            const color = _color.toRgb();
            return getColorInfo(color.r, color.g, color.b, color.a);
        });

    const tetradic = tiny.tetrad().map((_color) => {
        const color = _color.toRgb();
        return getColorInfo(color.r, color.g, color.b, color.a);
    });

    const triadic = tiny.triad().map((_color) => {
        const color = _color.toRgb();
        return getColorInfo(color.r, color.g, color.b, color.a);
    });

    return {
        ...colorInfo,
        complementary,
        analogous,
        monoChromatic,
        tetradic,
        triadic,
    };
};
